import apiClient from 'utils/apiClient';

const getMissingResources = (resource_type, school_id = null, params = {}) => {
  if (school_id) {
    params.school_id = school_id;
  }
  return apiClient.get(`v2/network/reports/${resource_type}`, {
    params,
  });
};

const networkService = () => ({ getMissingResources });

export default networkService;
